import React from 'react';
import clsx from 'clsx';
import { IconButton } from '../Button';
import { motion } from 'framer-motion';

interface ObservationSectionProps {
  title: string;
  className?: string;
  children: React.ReactNode;
  allowAdd?: boolean;
  isAdding?: boolean;
  onAddToggle?: () => void;
}

export const ObservationSection: React.FC<ObservationSectionProps> = ({
  title,
  children,
  className,
  allowAdd,
  isAdding,
  onAddToggle,
}) => {
  return (
    <motion.div layout="position" className={clsx(className)}>
      <div className="ObservationSection-Header mb-2 px-[22px] h-16 z-10 flex items-center justify-start sticky top-10 bg-darkMode-almostBlack">
        <h1 className="text-2xl font-bold text-white">{title}</h1>
        {allowAdd && (
          <IconButton icon={isAdding ? 'close' : 'add'} onClick={onAddToggle} className="ml-2" theme="text" />
        )}
      </div>
      {children}
    </motion.div>
  );
};

export default ObservationSection;
